import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'eis-gateway-checkmark',
  templateUrl: './checkmark.component.html',
  styleUrls: ['./checkmark.component.scss']
})
export class CheckmarkComponent implements OnInit {

  @Input()
  invert: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
